import React from 'react';

// Components
import GenderAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/gender_analytics';
import InterestsAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/interests_analytics';
import LocationAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/location_analytics';

function AudienceAnalytics(props) {
    const {bgColor, renderForPdf, getAssetPath} = props;

    return (
        <div className="audience-analytics wrap-up-section">
            <div className="audience-analytics-header-container">
                <div className="audience-analytics-header-title">Audience Analytics</div>
                <div className="audience-analytics-header-subtitle">
                    View insights on the audience that engaged with your content.
                </div>
            </div>
            <div className="audience-analytics-row-1">
                <GenderAnalytics
                    femalePercentage={props.audienceAnalysis.genders.percentages.female}
                    malePercentage={props.audienceAnalysis.genders.percentages.male}
                    borders={{right: true}}
                    renderForPdf={renderForPdf}
                    getAssetPath={getAssetPath}
                />
                <InterestsAnalytics
                    interests={props.audienceAnalysis.interests}
                    elementId="audience-analytics-interests"
                    borders={{left: true}}
                    renderForPdf={renderForPdf}
                    bgColor={bgColor}
                />
            </div>
            <div className="audience-analytics-row-2">
                <LocationAnalytics
                    countries={props.audienceAnalysis.countries}
                    states={props.audienceAnalysis.states}
                    borders={{}}
                    renderForPdf={renderForPdf}
                    getAssetPath={getAssetPath}
                />
            </div>

            {/*STYLES*/}

            <style>{`
            .audience-analytics {
            background-color: ${bgColor};
            width: 100%;
            }

            .audience-analytics-header-title {
            font-size: 36px;
            font-weight: 200;
            padding-top: 40px;
            }

            .audience-analytics-header-subtitle {
            width: 85%;
            font-size: 20px;
            font-weight: 200;
            text-align: center;
            padding: 10px 0px 40px 0px;
            }

            .audience-analytics-row-1 {
            width: 100%;
            padding: 40px 0px;
            border-bottom: 1px solid #d4d4d4;
            }

            .audience-analytics-row-2 {
            width: 100%;
            padding: 40px 0px;
            }
            `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
            .audience-analytics-header-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            }

            .audience-analytics-row-1 {
            display: flex;
            justify-content: center;
            }

            .audience-analytics-row-2 {
            display: flex;
            justify-content: center;
            }
            `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
            .audience-analytics {
            page-break-before: always;
            padding-top: 20px;
            }

            .audience-analytics-header-container {
            text-align: center;
            }

            .audience-analytics-header-subtitle {
            margin: auto;
            }

            .audience-analytics-row-1 {
            text-align: center;
            }

            .audience-analytics-row-2 {
            text-align: center;
            }
            `}</style>
            ) : null}
        </div>
    );
}

AudienceAnalytics.propTypes = {};

export default AudienceAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/audience_analytics/index.js